import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function LocalCameraNotAvailableDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("cameraNotAvailable")}
      text={t("messages.tryLater")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
